export enum ESocialMedia {
  facebook = "facebook",
  twitter = "twitter",
  telegram = "telegram",
  whatsapp = "whatsapp",
  line = "line",
  instagram = "instagram",
  copyLink = "copyLink",
  other = "other",
}